<template>
    <div>
        <el-dialog
                :close-on-click-modal="false"
                :show-close="false"
                :visible.sync="dialogVisible"
                width="300px">
            <div class="qrCodeClass">
                <div class="tc pr">
                    <vue-qr :logoSrc="imageUrl" :text="codeUrl" :size="200"></vue-qr>
                    <div class="pa  showCodeTip" v-if="showCodeTip">
                        <p class="qrcodeTip mb10 mt50">二维码已失效</p>
                        <el-button @click="refreshCode()" type="primary" plain>刷新二维码</el-button>
                    </div>
                    <p class="tc mt20">APP扫描二维码以完成人脸识别</p>
                </div>
            </div>
        </el-dialog>
        <section class="exam-content m0 cb pr mt15">
            <article class="fl exam-left">
                <h3 class="tc h3">{{ examPaperList.name }}</h3>
                <div class="exam-nav">
                    <ul class="m0">
                        <li class="first" v-if="questionList1.length > 0">
                            <a
                                    href="javascript:;"
                                    :class="{ active: type == '001001'}"
                                    @click="menuBtn('001001');"
                            >单选题</a>
                        </li>
                        <li v-if="questionList2.length > 0">
                            <a
                                    href="javascript:;"
                                    :class="{ active: type == '001002' }"
                                    @click="menuBtn('001002');"
                            >多选题</a>
                        </li>
                        <li v-if="questionList3.length > 0">
                            <a
                                    href="javascript:;"
                                    :class="{ active: type == '001003' }"
                                    @click="menuBtn('001003');"
                            >判断题</a>
                        </li>
                        <li v-if="questionList4.length > 0">
                            <a
                                    href="javascript:;"
                                    :class="{ active: type == '001004' }"
                                    @click="menuBtn('001004');"
                            >填空题</a>
                        </li>
                        <li v-if="questionList5.length > 0">
                            <a
                                    href="javascript:;"
                                    :class="{ active: type == '001005' }"
                                    @click="menuBtn('001005');"
                            >简答题</a>
                        </li>
                        <li v-if="questionList6.length > 0">
                            <a
                                    href="javascript:;"
                                    :class="{ active: type == '001006' }"
                                    @click="menuBtn('001006');"
                            >案例题</a>
                        </li>
                    </ul>
                </div>
                <div class="examOverscroll fl">
                    <div class="option-question m0 active">
                        <div v-show="type == '001001'">
                            <p class="explainText mt20 pl10">一、{{questionDescription['001001']}}</p>
                            <div class="option-div" v-for="(questionsItem,index) in questionList1" :key="index">
                                <i class="fl mr10 active">{{index + 1}}</i>
                                <h2 class="f14 fl" v-html="questionsItem.content"></h2>
                                <div
                                        class="option-list-radio ml40 cb"
                                        v-for="(choicesItem,index) in questionsItem.choices"
                                        :key="index"
                                >
                                    <div class="oh" >
                                        <el-radio v-model="questionsItem.userAnswer" :label="choicesItem.code">
                                            <span >{{choicesItem.code}}</span>
                                        </el-radio>
                                        <div class="oh fl" style="margin-top: 5px">
                                            <span v-html="choicesItem.content" class="exam-words fl"  > </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--多选题-->
                        <div v-show="type == '001002'">
                            <p class="explainText mt20 pl10">一、{{questionDescription['001002']}}</p>
                            <div class="option-div" v-for="(questionsItem,index) in questionList2" :key="index">
                                <i class="fl mr10 active">{{index + 1}}</i>
                                <h2 class="f14 fl " v-html="questionsItem.content"></h2>
                                <div class="option-list-radio ml40 cb">
                                    <el-checkbox-group v-model="questionsItem.userAnswer"
                                                       @change="handleCheckedCitiesChange">
                                        <div  v-for="(choicesItem,index) in questionsItem.choices"
                                              :key="index" class="oh">
                                        <el-checkbox
                                                :label="choicesItem.code">
                                            <span class="mr10">{{choicesItem.code}}</span>

                                        </el-checkbox>
                                        <div class="oh fl" style="margin-top: 5px">
                                            <span v-html="choicesItem.content" class="exam-words fl"  > </span>
                                        </div>
                                        </div>
                                    </el-checkbox-group>
                                </div>
                            </div>
                        </div>
                        <!--判断题-->
                        <div v-show="type == '001003'">
                            <p class="explainText mt20 pl10">一、{{questionDescription['001003']}}</p>
                            <div class="option-div" v-for="(questionsItem,index) in questionList3" :key="index">
                                <i class="fl mr10 active">{{index + 1}}</i>
                                <h2 class="f14 fl" v-html="questionsItem.content"></h2>
                                <div
                                        class="option-list-radio ml40 cb"
                                        v-for="(choicesItem,index) in questionsItem.choices"
                                        :key="index"
                                >
                                    <div class="oh">
                                        <el-radio v-model="questionsItem.userAnswer" :label="choicesItem.code">
                                            {{choicesItem.code}}
                                        </el-radio>
                                        <span v-html="choicesItem.content" class="exam-words fl mt5"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--填空题-->
                        <div v-show="type == '001004'">
                            <p class="explainText mt20 pl10">一、{{questionDescription['001004']}}</p>
                            <div
                                    class="option-div option-div-tk"
                                    v-for="(questionsItem,index) in questionList4"
                                    :key="index"
                            >
                                <div class="question-box">
                                    <i class="fl mr10 active">{{ index + 1 }}</i>
                                    <h2 class="f14 fl" v-html="questionsItem.content"></h2>
                                </div>
                                <p>
                                    <el-input
                                            type="text"
                                            class="mt30 mb10 ml10"
                                            v-for="(blanksNumbersItem,index) in questionsItem.blanksNumbers"
                                            :key="index"
                                            v-model="questionsItem.userAnswer"
                                            :label="blanksNumbersItem.code"
                                    ></el-input>
                                </p>
                            </div>
                        </div>
                        <!--简答题-->
                        <div v-show="type == '001005'">
                            <p class="explainText mt20 pl10">一、{{questionDescription['001005']}}</p>
                            <div class="option-div" v-for="(questionsItem,index) in questionList5" :key="index">
                                <div class="question-box">
                                    <i class="fl mr10 active">{{ index + 1 }}</i>
                                    <h2 class="f14 fl" v-html="questionsItem.content"></h2>
                                </div>
                                <div class="textarea">
                                    <el-input type="textarea" v-model="questionsItem.userAnswer"></el-input>
                                </div>
                            </div>
                        </div>
                        <!--案例题-->
                        <div v-show="type == '001006'">
                            <p class="explainText mt20 pl10">一、{{questionDescription['001006']}}</p>
                            <div class="option-div" v-for="(questionsItem,index) in questionList6" :key="index">
                                <div class="question-box">
                                    <i class="fl mr10 active">{{ index + 1 }}</i>
                                    <h2 class="f14 fl" v-html="questionsItem.content"></h2>
                                </div>
                                <div class="textarea">
                                    <el-input type="textarea" v-model="questionsItem.userAnswer"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
            <article class="fr exam-right">
                <div class="exam-right-box">
                    <div class="exam-txbox mt15 fl">
            <span class="pr fl">
              <i>
                <img src="/static/images/tx-vip_03.png" alt/>
              </i>
              <img
                      :src="userHeadImagUrl"
                      alt
                      width="53"
                      height="53"
                      style="display:block;border-radius:50px;"
              />
            </span>
                        <p class="fl">
                            <span>-{{realName}},上午好</span>
                            <span class="fl">总分 :</span>
                            <span class="fl score">&nbsp;&nbsp;{{ examPaperList.totalScore }}分</span>
                        </p>
                    </div>
                    <div class="sign-title fr">
                        <p>
              <span class="f12">
                <img src="/static/images/dt-bj.png" alt height="25"/>
                未答
              </span>
                            <span class="f12">
                <img src="/static/images/dt-bj3.png" alt height="25"/>
                已答
              </span>
                        </p>
                    </div>
                </div>
                <!--倒计时-->
                <div class="count-down">
                    <b>倒计时</b>
                    <div class="count-down-time">
                        <count-down
                                v-on:end_callback="perconCommit()"
                                :currentTime="currentTime"
                                :startTime="startTime"
                                :endTime="endTime"
                                :hourTxt="'时'"
                                :minutesTxt="'分'"
                                :secondsTxt="'秒'"
                        ></count-down>
                    </div>
                    <p class="prompt f14 tc">考试时间为{{ examPaperList.duration }}分钟，请把握时间</p>
                </div>
                <div class="selection-card">
                    <div class="exam-nav mb20">
                        <ul class="m0">
                            <li v-if="questionList1.length > 0">
                                <a
                                        href="javascript:;"
                                        :class="{ active: type == '001001' }"
                                        @click="menuBtn('001001');"
                                >单选题</a>
                            </li>
                            <li v-if="questionList2.length > 0">
                                <a
                                        href="javascript:;"
                                        :class="{ active: type == '001002' }"
                                        @click="menuBtn('001002');"
                                >多选题</a>
                            </li>
                            <li v-if="questionList3.length > 0">
                                <a
                                        href="javascript:;"
                                        :class="{ active: type == '001003' }"
                                        @click="menuBtn('001003');"
                                >判断题</a>
                            </li>
                            <li v-if="questionList4.length > 0">
                                <a
                                        href="javascript:;"
                                        :class="{ active: type == '001004' }"
                                        @click="menuBtn('001004');"
                                >填空题</a>
                            </li>
                            <li v-if="questionList5.length > 0">
                                <a
                                        href="javascript:;"
                                        :class="{ active: type == '001005' }"
                                        @click="menuBtn('001005');"
                                >简答题</a>
                            </li>
                            <li v-if="questionList6.length > 0">
                                <a
                                        href="javascript:;"
                                        :class="{ active: type == '001006' }"
                                        @click="menuBtn('001006');"
                                >案例题</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <!--选项卡-->
                <div class="optionsBox oh">
                    <!-- <a class="tc answered">5</a>
                      <a class="tc answered">9</a>
                      <a class="tc answered">13</a>
                    <a class="tc unanswered">17</a>-->
                    <div class="option-block m0" v-if="questionList1.length > 0">
                        <p v-for="(questionsItem,index) in questionList1" :key="index">
                            <a
                                    class="tc"
                                    v-show="type == '001001'"
                                    :class="{ unanswered: !questionsItem.userAnswer}"
                            >{{index + 1}}</a>
                        </p>
                    </div>
                    <div class="option-block m0" v-if="questionList2.length > 0">
                        <p v-for="(questionsItem,index) in questionList2" :key="index">
                            <a
                                    class="tc"
                                    v-show="type == '001002'"
                                    :class="{ unanswered: questionsItem.userAnswer.length == 0}"
                            >{{index + 1}}</a>
                        </p>
                    </div>
                    <div class="option-block m0" v-if="questionList3.length > 0">
                        <p v-for="(questionsItem,index) in questionList3" :key="index">
                            <a
                                    class="tc"
                                    v-show="type == '001003'"
                                    :class="{ unanswered: !questionsItem.userAnswer}"
                            >{{index + 1}}</a>
                        </p>
                    </div>
                    <div class="option-block m0" v-if="questionList4.length > 0">
                        <p v-for="(questionsItem,index) in questionList4" :key="index">
                            <a
                                    class="tc"
                                    v-show="type == '001004'"
                                    :class="{ unanswered: !questionsItem.userAnswer}"
                            >{{index + 1}}</a>
                        </p>
                    </div>
                    <div class="option-block m0" v-if="questionList5.length > 0">
                        <p v-for="(questionsItem,index) in questionList5" :key="index">
                            <a
                                    class="tc"
                                    v-show="types == '001005'"
                                    :class="{ unanswered: !questionsItem.userAnswer}"
                            >{{index + 1}}</a>
                        </p>
                    </div>
                    <div class="option-block m0" v-if="questionList6.length > 0">
                        <p v-for="(questionsItem,index) in questionList6" :key="index">
                            <a
                                    class="tc"
                                    v-show="type == '001006'"
                                    :class="{ unanswered: !questionsItem.userAnswer}"
                            >{{index + 1}}</a>
                        </p>
                    </div>
                </div>
                <p>
                    <a class="push-button cb tc" @click="submitExam()">我要交卷</a>
                </p>
            </article>
            <div class="page-bj cb "></div>
        </section>
    </div>
</template>
<style scoped>
    .explainText {
        height: 40px;
        background: #fbf3e8;
        line-height: 40px;
        margin: 0 auto;
    }

    .option-div .el-radio,
    .option-div .el-checkbox {
        white-space: inherit !important;
        line-height: 25px;
        float: left;
    }
    .exam-words{
        width: 550px;
    }
    .exam-words *{
        display: inline;
    }
    .option-list-radio .el-radio /deep/ .el-radio__label, .check_group .el-checkbox /deep/ .el-checkbox__label {
        white-space: normal;
    }
    .option-list-radio .el-radio {
        margin-right: 10px;
    }
    .option-list-radio .el-radio  /deep/  .el-radio__input{
        margin-top: 3px;
    }
</style>
<script>
    import vueQr from 'vue-qr'
    import ft from "../Footer"
    import headTop from "../Top"
    import '../../../static/css/exam-content.css'
    //加载组件面板
    import {Loading} from 'element-ui';
    //倒计时
    import CountDown from 'vue2-countdown';
    //全局对象 ... 结束时一定要清除.
    let FREQUENCY_TIMER;

    export default {
        data() {
            return {
                tip:null,
                ifExamTakePhoto:"",
                ifLoseFocusAutoSubmitPaper:"",
                timer:"",
                platformId:"",
                captureTheTiming: "",
                imageUrl: "",
                dialogVisible: false,
                codeUrl: "",
                examinationId: "",
                showCodeTip: false,
                examIntervalId: "",
                scanIntervalId: "",
                uuid: "",
                windowindex: "",
                intervalId: 0,
                count: 0,
                examPaperList: {},
                questionTypeSummaries: [],
                questionList1: [],
                questionList2: [],
                questionList3: [],
                questionList4: [],
                questionList5: [],
                questionList6: [],
                questionDescription: [],
                type: '001001',
                types: '001001',
                realName: "",
                userHeadImagUrl: "",
                //考试时长 (分钟)
                duration: null,
                //考试剩余时间
                remainingTime: null,
                //考试开始时间
                startTime: 0,
                //考试结束时间
                endTime: 0,
                //当前时间
                currentTime: 0
            }
        },
        methods: {

            /**
             * 获取二维码
             * @param id
             */
            getQrCode(captureTheTiming, tokenType, examinationId, userId) {
                this.captureTheTiming = captureTheTiming;
                var param = {
                    tokenType: tokenType,
                    userId: userId,
                    examId: examinationId
                };

                this.$axiosPackag.getMessageByAxios("POST", "/web/qrCode/createToken", null, param, {'Content-Type': 'application/json'}, resD => {
                    this.showCodeTip = false;
                    this.uuid = resD.uuid;
                    this.codeUrl = resD.url;
                    this.dialogVisible = true;
                    this.closeTiming();
                    this.examIntervalId = window.setInterval(() => {
                        this.getTokenStatus();
                    }, 2000);
                    this.scanIntervalId = window.setInterval(() => {
                        this.getScanStatus();
                    }, 2000);
                }, errorCall => {
                });


            },
            //查询人脸识别是否成功
            getTokenStatus() {
                this.$api.get("/web/qrCode/getTokenInfo", {uuid: this.uuid}, data => {
                    if (data.status == 0) {
                        if (data.data) {
                            if (data.data.status == 1) {
                                //验证完成清空定时器
                                this.stopQuartz();
                                this.dialogVisible = false;
                                this.$message.success("识别成功");
                                if (this.captureTheTiming == "start") {
                                } else if (this.captureTheTiming == "end") {
                                    this.tip="已交卷";
                                    this.saveExam();
                                }else if (this.captureTheTiming == "middle"){
                                    clearTimeout(this.timer);
                                }

                            }
                        } else {
                            this.stopQuartz();
                            this.showCodeTip = true;
                        }


                    } else {
                        this.stopQuartz();
                        this.showCodeTip = true;
                    }
                });


            },

            //查询扫描二维码是否成功
            getScanStatus() {

                this.$api.get("/web/qrCode/getTokenInfo", {uuid: this.uuid}, data => {
                    if (data.status == 0) {
                        if (data.data) {
                            if (data.data.scanStatus == 1) {
                                //验证完成清空定时器

                                window.clearInterval(this.scanIntervalId);
                                this.$message.success("扫码成功");
                            }

                        } else {
                            this.stopQuartz();
                            this.showCodeTip = true;
                        }

                    }
                });
            },

            stopQuartz() {
                window.clearInterval(this.examIntervalId);
                window.clearInterval(this.scanIntervalId);
            },
            perconCommit(){
                this.tip="已交卷";
                this.autoCommit();
            },
            /**
             * 倒计时结束了,自动提交试卷
             */
            autoCommit() {
                window.clearInterval(this.intervalId);
                this.submitExam(true);
            },
            packageSaveAnswer() {
                let answerData = [];
                for (var i = 0; i < this.questionList1.length; i++) {
                    if (this.questionList1[i].userAnswer) {
                        answerData.push({
                            'id': this.questionList1[i].id,
                            'userAnswer': this.questionList1[i].userAnswer
                        });
                    }
                }
                for (var i = 0; i < this.questionList2.length; i++) {
                    if (this.questionList2[i].userAnswer.length > 0) {
                        answerData.push({
                            'id': this.questionList2[i].id,
                            'userAnswer': this.questionList2[i].userAnswer.join(',')
                        });
                    }
                    // debugger
                }
                for (var i = 0; i < this.questionList3.length; i++) {
                    if (this.questionList3[i].userAnswer) {
                        answerData.push({
                            'id': this.questionList3[i].id,
                            'userAnswer': this.questionList3[i].userAnswer
                        });
                    }
                }
                for (var i = 0; i < this.questionList4.length; i++) {
                    if (this.questionList4[i].userAnswer) {
                        answerData.push({
                            'id': this.questionList4[i].id,
                            'userAnswer': this.questionList4[i].userAnswer
                        });
                    }
                }
                for (var i = 0; i < this.questionList5.length; i++) {
                    if (this.questionList5[i].userAnswer) {
                        answerData.push({
                            'id': this.questionList5[i].id,
                            'userAnswer': this.questionList5[i].userAnswer
                        });
                    }
                }
                for (var i = 0; i < this.questionList6.length; i++) {
                    if (this.questionList6[i].userAnswer) {
                        answerData.push({
                            'id': this.questionList6[i].id,
                            'userAnswer': this.questionList6[i].userAnswer
                        });
                    }
                }
                return answerData;
            },
            saveExam(isAuto) {
                //如果是自动交卷 ...直接设置为考试结束...否则的话 ,允许手动提交.
                if (isAuto) {
                    this.examIsEnd = true;
                }
                let allAnswerNumber = 0, hasAnswerNume = 0, unAnswerNumber = 0;
                for (var i = 0; i < this.questionList1.length; i++) {
                    if (this.questionList1[i].userAnswer) {
                        hasAnswerNume++;
                    } else {
                        unAnswerNumber++;
                    }
                    allAnswerNumber++;
                }
                for (var i = 0; i < this.questionList2.length; i++) {
                    if (this.questionList2[i].userAnswer.length > 0) {
                        hasAnswerNume++;
                    } else {
                        unAnswerNumber++;
                    }
                    allAnswerNumber++;
                }
                for (var i = 0; i < this.questionList3.length; i++) {
                    if (this.questionList3[i].userAnswer) {
                        hasAnswerNume++;
                    } else {
                        unAnswerNumber++;
                    }
                    allAnswerNumber++;
                }
                for (var i = 0; i < this.questionList4.length; i++) {
                    if (this.questionList4[i].userAnswer) {
                        hasAnswerNume++;
                    } else {
                        unAnswerNumber++;
                    }
                    allAnswerNumber++;
                }
                for (var i = 0; i < this.questionList5.length; i++) {
                    if (this.questionList5[i].userAnswer) {
                        hasAnswerNume++;
                    } else {
                        unAnswerNumber++;
                    }
                    allAnswerNumber++;
                }
                for (var i = 0; i < this.questionList6.length; i++) {
                    if (this.questionList6[i].userAnswer) {
                        hasAnswerNume++;
                    } else {
                        unAnswerNumber++;
                    }
                    allAnswerNumber++;
                }
                if (!isAuto) {
                    this.$confirm('共' + allAnswerNumber + '题,已答' + hasAnswerNume + '题,未答' + unAnswerNumber + '题, 是否交卷?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.tip="已交卷";
                        this.submitConfirme();
                    }).catch(() => {

                    });
                } else {
                    this.submitConfirme();
                }

            },
            /**
             * 提交试卷
             */
            submitExam(isAuto,str) {
                if(!this.$util.isBlackStr(str)){
                    this.tip=str;
                }
                if(isAuto){
                    this.saveExam(isAuto);
                }else{
                    if(this.ifExamTakePhoto=="1"){
                        this.getQrCode("end", "004", this.examId, this.$sessionStore.getUserId());
                    }else{
                        this.saveExam(isAuto);
                    }
                }
            },

            /**
             *确定提交
             */
            submitConfirme() {
                this.backSendUserAnswer();
                let answerData = this.packageSaveAnswer();
                //没有任何答题记录
                //   if (answerData.length <= 0) {
                //     this.$confirm('您没有作答', '提示')
                //     return;
                //   }
                var param = {
                    'recordId': this.examPaperList.recordId,
                    'answerData': JSON.stringify(answerData)
                };
                this.$axiosPackag.getMessageByAxios("POST", "/api/student/onlineExam/submit", param, null, null, resD => { 
                    //交卷成功
                    //  this.$confirm('交卷成功！', '提示');
                    if(this.$util.isBlackStr(this.tip)){
                        this.tip="光标失去焦点超过10秒钟已自动交卷";
                    }
                    this.$confirm(
                        '提示',
                        {
                            title: '提示',
                            message: this.tip,
                            showCancelButton: false,
                            confirmButtonText: '确定',
                            closeOnClickModal:false,
                            showClose:false,
                            type: 'success'
                        }).then(() => {
                        window.location.href = '/web/examination/index';
                    })
                    //  this.$router.push({ path: '/personal/myexam' });

                }, errorD => {
                   
                });
            },
            /**
             * 定时保存,该用户的答题记录
             */
            intervalTimer() {
                //清除之前的定时器
                clearInterval(FREQUENCY_TIMER);
                FREQUENCY_TIMER = setInterval(() => {
                    this.backSendUserAnswer();
                }, 5 * 60 * 1000);
            },
            /**
             *定时发送,当前考试的数据包
             */
            backSendUserAnswer() {
                let answerData = this.packageSaveAnswer();
                //没有任何答题记录
                if (answerData.length <= 0) {  
                    return;
                }
                var param = {
                    'recordId': this.examPaperList.recordId,
                    'answerData': JSON.stringify(answerData)
                };
                this.$axiosPackag.getMessageByAxios("POST", "/api/student/onlineExam/saveAnswer", param, null, null, resD => {
                }, errorD => {
                });
            },
            /**
             * 鼠标离开页面后10秒或者离开5次自动交卷
             */
            timing() {
                this.count++;
                console.info(this.count);
                if (this.count > 5) {
                    this.tip="光标失去焦点大于5次已自动交卷";
                    this.autoCommit();
                    return;
                }
                console.info("触发定时");
                window.clearInterval(this.intervalId);
                this.intervalId = setInterval(this.autoCommit, 10000);
            },
            /**
             * 关闭定时
             */
            closeTiming() {
                console.info("清除");
                window.clearInterval(this.intervalId);
            },
            examPaperData() {
                this.$axiosPackag.getMessageByAxios("GET", "/api/student/onlineExam/enterExamination", {"id": this.examId}, null, null, res => {
                    this.examPaperList = res
                    this.questionTypeSummaries = res.questionTypeSummaries
                    //考试总时长  分钟
                    this.duration = parseInt(res.duration);
                    //剩余时长   毫秒级别
                    this.remainingTime = res.remainingTime;
                    if(this.ifExamTakePhoto=="1"){
                        let openCodeTime=this.remainingTime/2;
                        this.timer = setTimeout(this.openQrcode,  openCodeTime);
                    }
                    //直接调用开始考试
                    this.beginExam();
                    var firstIndex="";
                    for (var i = 0; i < this.questionTypeSummaries.length; i++) {
                        for (var j = 0; j < this.questionTypeSummaries[i].questions.length; j++) {
                            var question = this.questionTypeSummaries[i].questions[j];
                            question.content = this.$util.html(question.content)
                            question.analysis = this.$util.html(question.analysis)
                            question.answer = this.$util.html(question.answer)
                            if (question.choices) {
                                for (var q = 0; q < question.choices.length; q++) {
                                    question.choices[q].content = this.$util.html(question.choices[q].content)
                                }
                            }
                            if (question.blanksNumber) {
                                let blanksNumber = parseInt(question.blanksNumber);
                                question.blanksNumbers = [];
                                for (let f = 0; f < blanksNumber; f++) {
                                    let op = {};
                                    op.userAnswer = [];
                                    question.blanksNumbers.push(op);
                                }
                            }
                            if (question.type == '001001') {
                                this.questionList1.push(question);
                                firstIndex='001001';
                            } else if (question.type == '001002') {
                                question.userAnswer = question.userAnswer ? question.userAnswer.split(',') : [];
                                this.questionList2.push(question);
                                if(firstIndex==''){
                                    firstIndex='001002';
                                }
                            } else if (question.type == '001003') {
                                this.questionList3.push(question);
                                if(firstIndex==''){
                                    firstIndex='001003';
                                }
                            } else if (question.type == '001004') {
                                this.questionList4.push(question);
                                if(firstIndex==''){
                                    firstIndex='001004';
                                }
                            } else if (question.type == '001005') {
                                this.questionList5.push(question);
                                if(firstIndex==''){
                                    firstIndex='001005';
                                }
                            } else if (question.type == '001006') {
                                this.questionList6.push(question);
                                if(firstIndex==''){
                                    firstIndex='001006';
                                }
                            }
                            this.questionDescription[question.type] = this.questionTypeSummaries[i].description;
                        }
                    }
                    //if(this.questionList1.length==0){
                        this.menuBtn(firstIndex);
                    //}
                });
            },
            handleCheckedCitiesChange(value) {

                for (var i = 0; i < this.questionList2.length; i++) {
                    this.$set(this.questionList2, i, this.questionList2[i])
                }

                // debugger
                console.log(value)
            },
            menuBtn(type) {
                this.type = type;
            },
            menuBtns(types) {
                this.types = types;
            },
            /**
             *开始考试按钮
             */
            beginExam() {
                let sumTime = 0;
                if (this.remainingTime) {
                    //此处是毫秒值
                    sumTime = parseInt(this.remainingTime);
                } else {
                    sumTime = parseInt(this.duration) * 60 * 1000;
                }
                this.startTime = (new Date()).getTime();
                this.endTime = this.startTime + sumTime;
                this.currentTime = this.startTime;
                this.intervalTimer();
            },
            refreshCode(){
                this.getQrCode(null, "004", this.examId, this.$sessionStore.getUserId())
            },
            openQrcode(){
                this.getQrCode("middle", "004", this.examId, this.$sessionStore.getUserId())
            }
        },
        components: {
            vueQr,
            headTop,
            ft,
            CountDown,
        },
        mounted() {
            this.examId = this.$route.query.id;
            this.ifExamTakePhoto = this.$route.query.ifExamTakePhoto;
            //是否考试抓拍
            if(this.ifExamTakePhoto=="1"){
                this.getQrCode("start", "004", this.examId, this.$sessionStore.getUserId());
            }
            //是否失去焦点自动交卷
            if(this.ifLoseFocusAutoSubmitPaper=="1"){
                window.addEventListener('blur', e => this.timing(e), false);
                window.addEventListener('focus', e => this.closeTiming(e), false);
            }
            this.examPaperData();
            console.log(this.questionList2)
        },
        destroyed() {
            if(this.ifLoseFocusAutoSubmitPaper=="1"){
                window.removeEventListener('blur', e => this.timing(e), false)
                window.removeEventListener('focus', e => this.closeTiming(e), false)
            }

        }
    }
</script>
<style scoped>
    .el-checkbox-group span {
        color: #666 !important;
        font-size: 14px;
        font-family: '宋体';

    }

    .qrCodeClass .showCodeTip{
        top:19px;
        left: 43px;
        background: #fff;
        width: 200px;
        height:200px;
    }
    .qrCodeClass .qrcodeTip {
        color: #333;
    }

</style>



// WEBPACK FOOTER //
// ExamPaper.vue?d4f043d8